import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const deleteSurgicalActEndpoint = async surgicalActId => {
  if (!surgicalActId) {
    throw new Error("surgicalActId is required");
  }

  const endpoint = API_ENDPOINTS.DELETE_SURGICAL_ACT(surgicalActId);
  try {
    const response = await apiClient.delete(endpoint);
    return response;
  } catch (error) {
    throw new Error(`Error deleting surgical act: ${error.message}`);
  }
};

export const addSurgicalActEndpoint = async data => {
  const endpoint = API_ENDPOINTS.CREATE_SURGICAL_ACT();
  try {
    const response = await apiClient.post(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error adding surgical act: ${error.message}`);
  }
};

export const updateSurgicalActEndpoint = async (data, surgicalActId) => {
  if (!surgicalActId) {
    throw new Error("surgicalActId is required");
  }

  const endpoint = API_ENDPOINTS.UPDATE_SURGICAL_ACT(surgicalActId);
  try {
    const response = await apiClient.patch(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error updating surgical act: ${error.message}`);
  }
};
